import { createContext } from "react"

const AccessVehiclesContext = createContext();

export default AccessVehiclesContext;